export default __webpack_public_path__ + "static/media/winner.fec49150.png";